import React from "react";
import { t } from "i18next";

const StatusView = () => {
  return (
    <div className="chat-online-status mx-3">
      <small className="status-indicator online">{t("online")}</small>
    </div>
  );
};

export default StatusView;
